function setCookie(cookieName: string, cookieValue: string, expirationDays: number, domain?: string): void {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + expirationDays);

  const cookieString = `${cookieName}=${cookieValue}; expires=${expirationDate.toUTCString()}; path=/ ${domain ? `; domain=${domain}` : ''}`;
  document.cookie = cookieString;
}

export default setCookie;
